/**
 * Radix would land focus on the close button, the first thing in the box, and
 * ring it the moment the dialog opens. The dialog itself takes focus instead:
 * Tab still walks into the close button and on from there. For
 * `DialogContent`'s `onOpenAutoFocus`; the box wants `outline-none`.
 */
export function focusDialogOnOpen(event: Event) {
  event.preventDefault();
  if (event.currentTarget instanceof HTMLElement) event.currentTarget.focus();
}
